export enum FeedbackVariant {
	AFTER_AIFC_MODAL_CLOSE = 'after-aifc-modal-close',
	AFTER_UPDATE_STREAM_COMPLETE = 'after-update-stream-complete',
	AFTER_REMIX_MODAL_CLOSE = 'after-remix-modal-close',
	AFTER_REMIX_INSERT = 'after-remix-insert',
}
